import React from "react";
import { MODULES } from "@/lib/modules";
import { ResourceView } from "@/components/common/ResourceView";

export default function GenericModule({ moduleKey }) {
  const cfg = MODULES[moduleKey];
  if (!cfg) return null;
  return <ResourceView {...cfg} />;
}
